import React from 'react';
import {connect} from 'react-redux';
import MPPCreateChallengeEditor from '../MPPCreateChallengeEditor';

const MPPChallenge = () => (
  <div id="challenge-MPP">
    <section className="content">
      <MPPCreateChallengeEditor />
    </section>
  </div>
);

export default connect(
  state => ({}),
  dispatch => ({dispatch}),
)(MPPChallenge);



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/Challenge/index.js